import { render, staticRenderFns } from "./DocumentsDialog.vue?vue&type=template&id=10670207&"
import script from "./DocumentsDialog.vue?vue&type=script&lang=js&"
export * from "./DocumentsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports